import {Component, Input, OnInit} from '@angular/core';
import {FieldType} from "@ngx-formly/core";

@Component({
  selector: 'formly-select-field',
  template: `
    <ds-hybrid-field
      name="{{label}}"
      [id]="label"
      placeholder="{{label}}"
      required="{{ required }}"
      label="{{ label }}"
      noresults="No results found"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [invalid]="invalid"
    >

      <ds-menu-item *ngFor="let item of to.options" [value]="item.label">
        {{item.value}}
      </ds-menu-item>

    </ds-hybrid-field>
  `,
  styles: [],
})
export class FormlySelectFieldComponent extends FieldType implements OnInit {
  @Input() helpertext: string;
  @Input() label: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() required?: boolean;
  @Input()
  invalidtext: string;
  public get invalid(): boolean {
    return this.formControl?.touched ? this.formControl.invalid : false;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.label = this.to.label;
    this.placeholder = this.to.placeholder;
    this.helpertext = this.to.helpertext;
    this.required = this.to.required;
    this.name = this.key.toString();
    this.invalidtext = this.to.invalidtext;
  }
}
